export { default } from './components/radio.list';
